module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/auth/components/confirmar-email/confirmar-email.component.scss
// module id = ./src/app/modules/auth/components/confirmar-email/confirmar-email.component.scss
// module chunks = main